import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { X, ChevronLeft, ChevronRight, Loader2, AlertCircle } from 'lucide-react';
import apiClient from '../../services/apiClient';
import {
  ProcessorStep1BasicInfo,
  ProcessorStep2Operations,
  ProcessorStep3Methods,
  ProcessorStep4Marketing,
  ProcessorStep5Insights,
} from './processor-steps';

export function AddProcessorForm({ onClose, onAddProcessor, editData }) {
  const isEditMode = !!editData;
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;

  const [formData, setFormData] = useState({
    // Basic Business Information
    nameOfBusiness: editData ? (editData.nameOfBusiness || editData.businessName || '') : '',
    address: editData ? (editData.address || '') : '',
    contactNumbers: editData ? (editData.contact || '') : '',
    lengthOfBusinessOperationInYears: editData ? (editData.lengthOfBusinessOperationInYears || editData.yearsInOperation || '') : '',
    statusOfBusiness: editData ? (editData.statusOfBusiness || editData.businessStatus || '') : '',
    typeOfBusiness: editData ? (editData.typeOfBusiness || editData.businessType || '') : '',
    nameOfTheOwner: editData ? (editData.nameOfTheOwner || editData.ownerName || '') : '',
    addressOwner: editData ? (editData.addressOwner || '') : '',
    initialInvestment: editData ? (editData.initialInvestment || '') : '',
    averageAnnualGrossIncome: editData ? (editData.averageAnnualGrossIncome || '') : '',
    numberOfEmployees: editData ? (editData.numberOfEmployees || '') : '',
    type: editData ? (editData.employeeType || editData.type || '') : '',
    
    // Processing Operations
    quantityOfCacaoBeansPerProcessingCycle: editData ? (editData.quantityOfCacaoBeansPerProcessingCycle || editData.processingCapacity || '') : '',
    frequencyOfProcessing: editData ? (editData.frequencyOfProcessing || '') : '',
    preferredVarietyOfCacao: editData ? (editData.preferredVarietyOfCacao || '') : '',
    varietyOfCacaoProcessed: editData ? (editData.varietyOfCacaoProcessed || '') : '',
    sourceOfCacao: editData ? (editData.sourceOfCacao || '') : '',
    producersToProcessors: editData ? (editData.producersToProcessors || '') : '',
    localTradersToProcessors: editData ? (editData.localTradersToProcessors || '') : '',
    frequencyOfDelivery: editData ? (editData.frequencyOfDelivery || '') : '',
    quantityOfCacaoDelivered: editData ? (editData.quantityOfCacaoDelivered || '') : '',
    formTypeOfCacaoBought: editData ? (editData.formTypeOfCacaoBought || '') : '',
    formType: editData ? (editData.formType || '') : '',
    
    // Post-Harvest Processing Methods
    podBreaking: editData ? (editData.podBreaking || '') : '',
    beanExtraction: editData ? (editData.beanExtraction || '') : '',
    fermentation: editData ? (editData.fermentation || '') : '',
    containmentMaterials: editData ? (editData.containmentMaterials || '') : '',
    numberOfDays: editData ? (editData.numberOfDays || '') : '',
    temperatureMonitoring: editData ? (editData.temperatureMonitoring || 'No') : 'No',
    preferredFermentationTemperature: editData ? (editData.preferredFermentationTemperature || '') : '',
    dryingReDrying: editData ? (editData.dryingReDrying || '') : '',
    typeDrying: editData ? (editData.dryingType || editData.typeDrying || '') : '',
    preferredMoistureContent: editData ? (editData.preferredMoistureContent || '') : '',
    methodOfMCDetermination: editData ? (editData.methodOfMcDetermination || editData.methodOfMCDetermination || '') : '',
    beanSorting: editData ? (editData.beanSorting || '') : '',
    usualBeanSize: editData ? (editData.usualBeanSize || '') : '',
    beanGrading: editData ? (editData.beanGrading || '') : '',
    levelOfFermentation: editData ? (editData.levelOfFermentation || '') : '',
    rawBeanAroma: editData ? (editData.rawBeanAroma || '') : '',
    materialsUsedForDriedBeanStorage: editData ? (editData.materialsUsedForDriedBeanStorage || '') : '',
    estimatedCostOfMaterials: editData ? (editData.estimatedCostOfMaterials || '') : '',
    
    // Advanced Processing Techniques
    roasting: editData ? (editData.roasting || 'No') : 'No',
    roastingMethod: editData ? (editData.roastingMethod || '') : '',
    averageTimeSpent: editData ? (editData.averageTimeSpent || '') : '',
    roastingTemperatureMonitoring: editData ? (editData.roastingTemperatureMonitoring || 'No') : 'No',
    preferredRoastingTemperature: editData ? (editData.preferredRoastingTemperature || '') : '',
    cracking: editData ? (editData.cracking || 'No') : 'No',
    crackingType: editData ? (editData.crackingType || '') : '',
    winnowing: editData ? (editData.winnowing || 'No') : 'No',
    winnowingType: editData ? (editData.winnowingType || '') : '',
    grinding: editData ? (editData.grinding || 'No') : 'No',
    grindingType: editData ? (editData.grindingType || '') : '',
    conching: editData ? (editData.conching || 'No') : 'No',
    preferredMicronsSize: editData ? (editData.preferredMicronsSize || '') : '',
    tempering: editData ? (editData.tempering || 'No') : 'No',
    temperingType: editData ? (editData.temperingType || '') : '',
    preferredTemperingTemperature: editData ? (editData.temperingTemp || editData.preferredTemperingTemperature || '') : '',
    moulding: editData ? (editData.moulding || 'No') : 'No',
    mouldingType: editData ? (editData.mouldingType || '') : '',
    storageOfProcessedProduct: editData ? (editData.storageOfProcessedProduct || '') : '',
    preferredStorageTemperature: editData ? (editData.preferredStorageTemperature || '') : '',
    preferredRelativeHumidity: editData ? (editData.preferredRelativeHumidity || '') : '',
    packagingMaterial: editData ? (editData.packagingMaterial || '') : '',
    
    // Marketing and Sales
    marketing: editData ? (editData.marketing || '') : '',
    typeOfProductSold: editData ? (editData.typeOfProductSold || '') : '',
    typeOfMarketing: editData ? (editData.typeOfMarketing || '') : '',
    market: editData ? (editData.market || '') : '',
    marketplace: editData ? (editData.marketplace || '') : '',
    localMarket: editData ? (editData.localMarket || '') : '',
    international: editData ? (editData.international || '') : '',
    
    // Business Insights
    whatInterestYouToGoOnCacaoProcessing: editData ? (editData.whatInterestYouToGoOnCacaoProcessing || '') : '',
    challengesEncounteredInProcessing: editData ? (editData.challengesEncounteredInProcessing || '') : '',
    supportsNeededToImprove: editData ? (editData.supportsNeededToImprove || '') : '',
    futurePlans: editData ? (editData.futurePlans || '') : '',
    
    // Location
    latitude: editData ? (editData.latitude || '') : '',
    longitude: editData ? (editData.longitude || '') : '',
    municipality: editData ? (editData.municipality || '') : '',
    barangay: editData ? (editData.barangay || '') : ''
  });

  const [productTypes, setProductTypes] = useState(
    editData && editData.typeOfProductSold
      ? (Array.isArray(editData.typeOfProductSold)
          ? editData.typeOfProductSold
          : typeof editData.typeOfProductSold === 'string'
            ? editData.typeOfProductSold.split(',').map(p => p.trim()).filter(Boolean)
            : [])
      : []
  );
  const [newProduct, setNewProduct] = useState('');
  const [cacaoVarieties, setCacaoVarieties] = useState(
    editData && editData.varietyOfCacaoProcessed
      ? (Array.isArray(editData.varietyOfCacaoProcessed)
          ? editData.varietyOfCacaoProcessed
          : typeof editData.varietyOfCacaoProcessed === 'string'
            ? editData.varietyOfCacaoProcessed.split(',').map(v => v.trim()).filter(Boolean)
            : [])
      : []
  );
  const [newCacaoVariety, setNewCacaoVariety] = useState('');
  
  // API states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Phone number validation function
  const handlePhoneChange = (value) => {
    // Only allow numbers, spaces, hyphens, parentheses, and plus sign
    const phoneRegex = /^[0-9+\-\s()]*$/;
    if (phoneRegex.test(value)) {
      setFormData(prev => ({ ...prev, contactNumbers: value }));
    }
  };

  const addProduct = () => {
    if (newProduct.trim() && !productTypes.includes(newProduct.trim())) {
      setProductTypes(prev => [...prev, newProduct.trim()]);
      setNewProduct('');
    }
  };

  const removeProduct = (product) => {
    setProductTypes(prev => prev.filter(p => p !== product));
  };

  const addCacaoVariety = () => {
    if (newCacaoVariety.trim() && !cacaoVarieties.includes(newCacaoVariety.trim())) {
      setCacaoVarieties(prev => [...prev, newCacaoVariety.trim()]);
      setNewCacaoVariety('');
    }
  };

  const removeCacaoVariety = (variety) => {
    setCacaoVarieties(prev => prev.filter(v => v !== variety));
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Only allow submission on the last step
    if (currentStep !== totalSteps) {
      return false;
    }
    setIsSubmitting(true);
    setSubmitError(null);
    
    try {
      // Structure data according to your backend API expectations
      const businessData = {
        // Business Information
        name: formData.nameOfBusiness || null,
        address: formData.address || null,
        municipality: formData.municipality || null,
        barangay: formData.barangay || null,
        contact: formData.contactNumbers || null,
        years: formData.lengthOfBusinessOperationInYears ? parseInt(formData.lengthOfBusinessOperationInYears) : null,
        status: formData.statusOfBusiness || null,
        businessType: formData.typeOfBusiness || null,
        owner: formData.nameOfTheOwner || null,
        ownerAddress: formData.addressOwner || null,
        investment: formData.initialInvestment ? parseFloat(formData.initialInvestment) : null,
        income: formData.averageAnnualGrossIncome ? parseFloat(formData.averageAnnualGrossIncome) : null,
        employees: formData.numberOfEmployees ? parseInt(formData.numberOfEmployees) : null,
        type: formData.type || null,
        lat: formData.latitude ? parseFloat(formData.latitude) : null,
        long: formData.longitude ? parseFloat(formData.longitude) : null,

        // Processing Data
        processingData: {
          cacaoQty: formData.quantityOfCacaoBeansPerProcessingCycle ? parseFloat(formData.quantityOfCacaoBeansPerProcessingCycle) : null,
          processingFrequency: formData.frequencyOfProcessing || null,
          preferredVariety: formData.preferredVarietyOfCacao || null,
          processedVariety: cacaoVarieties.length > 0 ? cacaoVarieties.join(',') : null,
          sourceCacao: formData.sourceOfCacao || null,
          producersToProcessors: formData.producersToProcessors || null,
          localTradersToProcessors: formData.localTradersToProcessors || null,
          deliveryFrequency: formData.frequencyOfDelivery || null,
          deliveryQuantity: formData.quantityOfCacaoDelivered ? parseFloat(formData.quantityOfCacaoDelivered) : null,
          cacaoForm: formData.formTypeOfCacaoBought || null,
          formType: formData.formType || null
        },

        // Post Harvest Data
        postHarvestData: {
          podBreaking: formData.podBreaking || null,
          beanExtraction: formData.beanExtraction || null,
          fermentation: formData.fermentation || null,
          containment: formData.containmentMaterials || null,
          days: formData.numberOfDays ? parseInt(formData.numberOfDays) : null,
          tempMonitoring: formData.temperatureMonitoring || null,
          preferredTemp: formData.preferredFermentationTemperature ? parseFloat(formData.preferredFermentationTemperature) : null,
          drying: formData.dryingReDrying || null,
          dryingType: formData.typeDrying || null,
          moistureContent: formData.preferredMoistureContent ? parseFloat(formData.preferredMoistureContent) : null,
          mcMethod: formData.methodOfMCDetermination || null,
          beanSorting: formData.beanSorting || null,
          beanSize: formData.usualBeanSize || null,
          beanGrading: formData.beanGrading || null,
          fermentationLevel: formData.levelOfFermentation ? parseFloat(formData.levelOfFermentation) : null,
          aroma: formData.rawBeanAroma || null,
          storageMaterials: formData.materialsUsedForDriedBeanStorage || null,
          storageCost: formData.estimatedCostOfMaterials ? parseFloat(formData.estimatedCostOfMaterials) : null
        },

        // Techniques Data
        techniquesData: {
          roasting: formData.roasting || null,
          roastingMethod: formData.roasting === 'Yes' ? (formData.roastingMethod || null) : null,
          roastingTime: formData.averageTimeSpent || null,
          roastTempMonitoring: formData.roastingTemperatureMonitoring || null,
          preferredRoastTemp: formData.preferredRoastingTemperature || null,
          cracking: formData.cracking || null,
          crackingType: formData.cracking === 'Yes' ? (formData.crackingType || null) : null,
          winnowing: formData.winnowing || null,
          winnowingType: formData.winnowing === 'Yes' ? (formData.winnowingType || null) : null,
          grinding: formData.grinding || null,
          grindingType: formData.grinding === 'Yes' ? (formData.grindingType || null) : null,
          conching: formData.conching || null,
          microns: formData.preferredMicronsSize ? parseFloat(formData.preferredMicronsSize) : null,
          tempering: formData.tempering || null,
          temperingType: formData.tempering === 'Yes' ? (formData.temperingType || null) : null,
          temperingTemp: formData.preferredTemperingTemperature || null,
          moulding: formData.moulding || null,
          mouldingType: formData.moulding === 'Yes' ? (formData.mouldingType || null) : null,
          storageProcessed: formData.storageOfProcessedProduct || null,
          storageTemp: formData.preferredStorageTemperature || null,
          storageRH: formData.preferredRelativeHumidity || null,
          packagingMaterial: formData.packagingMaterial || null
        },

        // Marketing Data
        marketingData: {
          marketing: formData.marketing || null,
          productType: productTypes.length > 0 ? productTypes.join(',') : null,
          marketingType: formData.typeOfMarketing || null,
          market: formData.market || null,
          marketplace: formData.marketplace || null,
          localMarket: formData.localMarket || null,
          international: formData.international || null
        },

        // Insights Data - Use short field names that match backend route destructuring
        insightsData: {
          interest: formData.whatInterestYouToGoOnCacaoProcessing || null,
          challenges: formData.challengesEncounteredInProcessing || null,
          supports: formData.supportsNeededToImprove || null,
          plans: formData.futurePlans || null
        }
      };

      // Debug: show exact payload being sent to the API
      let result;
      if (isEditMode) {
        // Update existing processor
        const axiosResponse = await apiClient.put(`/processors/businesses/${editData.id}`, businessData);
        result = axiosResponse.data;
        if (!result.success) {
          throw new Error(result.error || result.message || 'Failed to update business data');
        }
      } else {
        // Insert new processor
        const axiosResponse = await apiClient.post('/processors/insert_business', businessData);
        result = axiosResponse.data;
        if (!result.success) {
          throw new Error(result.error || result.message || 'Failed to insert business data');
        }
      }

      // Create a processor object for the frontend state with ALL data
      const newProcessor = {
        id: isEditMode ? editData.id || editData.profileId || editData.profile_id : result.data.profileId || result.data.profile_id,
        businessName: formData.nameOfBusiness,
        displayName: formData.nameOfBusiness,
        ownerName: formData.nameOfTheOwner,
        address: formData.address,
        municipality: formData.municipality,
        barangay: formData.barangay,
        contact: formData.contactNumbers,
        businessType: formData.typeOfBusiness,
        businessStatus: formData.statusOfBusiness,
        yearsInOperation: formData.lengthOfBusinessOperationInYears ? parseInt(formData.lengthOfBusinessOperationInYears) : 0,
        initialInvestment: formData.initialInvestment ? parseFloat(formData.initialInvestment) : null,
        averageAnnualGrossIncome: formData.averageAnnualGrossIncome ? parseFloat(formData.averageAnnualGrossIncome) : null,
        numberOfEmployees: formData.numberOfEmployees ? parseInt(formData.numberOfEmployees) : null,
        type: formData.type,
        addressOwner: formData.addressOwner,
        latitude: formData.latitude ? parseFloat(formData.latitude) : null,
        longitude: formData.longitude ? parseFloat(formData.longitude) : null,
        
        // Processing Operations
        processingCapacity: formData.quantityOfCacaoBeansPerProcessingCycle ? parseFloat(formData.quantityOfCacaoBeansPerProcessingCycle) : 0,
        frequencyOfProcessing: formData.frequencyOfProcessing,
        preferredVarietyOfCacao: formData.preferredVarietyOfCacao,
        varietyOfCacaoProcessed: cacaoVarieties,
        sourceOfCacao: formData.sourceOfCacao,
        producersToProcessors: formData.producersToProcessors,
        localTradersToProcessors: formData.localTradersToProcessors,
        frequencyOfDelivery: formData.frequencyOfDelivery,
        quantityOfCacaoDelivered: formData.quantityOfCacaoDelivered ? parseFloat(formData.quantityOfCacaoDelivered) : null,
        formTypeOfCacaoBought: formData.formTypeOfCacaoBought,
        formType: formData.formType,
        
        // Post-Harvest Methods
        podBreaking: formData.podBreaking,
        beanExtraction: formData.beanExtraction,
        fermentation: formData.fermentation,
        containmentMaterials: formData.containmentMaterials,
        numberOfDays: formData.numberOfDays ? parseInt(formData.numberOfDays) : null,
        temperatureMonitoring: formData.temperatureMonitoring,
        preferredFermentationTemperature: formData.preferredFermentationTemperature ? parseFloat(formData.preferredFermentationTemperature) : null,
        dryingReDrying: formData.dryingReDrying,
        typeDrying: formData.typeDrying,
        preferredMoistureContent: formData.preferredMoistureContent ? parseFloat(formData.preferredMoistureContent) : null,
        methodOfMCDetermination: formData.methodOfMCDetermination,
        beanSorting: formData.beanSorting,
        usualBeanSize: formData.usualBeanSize,
        beanGrading: formData.beanGrading,
        levelOfFermentation: formData.levelOfFermentation ? parseFloat(formData.levelOfFermentation) : null,
        rawBeanAroma: formData.rawBeanAroma,
        materialsUsedForDriedBeanStorage: formData.materialsUsedForDriedBeanStorage,
        estimatedCostOfMaterials: formData.estimatedCostOfMaterials ? parseFloat(formData.estimatedCostOfMaterials) : null,
        
        // Advanced Processing Techniques
        roasting: formData.roasting,
        roastingMethod: formData.roastingMethod,
        averageTimeSpent: formData.averageTimeSpent,
        roastingTemperatureMonitoring: formData.roastingTemperatureMonitoring,
        preferredRoastingTemperature: formData.preferredRoastingTemperature || null,
        cracking: formData.cracking,
        crackingType: formData.crackingType,
        winnowing: formData.winnowing,
        winnowingType: formData.winnowingType,
        grinding: formData.grinding,
        grindingType: formData.grindingType,
        conching: formData.conching,
        preferredMicronsSize: formData.preferredMicronsSize ? parseFloat(formData.preferredMicronsSize) : null,
        tempering: formData.tempering,
        temperingType: formData.temperingType,
        preferredTemperingTemperature: formData.preferredTemperingTemperature || null,
        moulding: formData.moulding,
        mouldingType: formData.mouldingType,
        storageOfProcessedProduct: formData.storageOfProcessedProduct,
        preferredStorageTemperature: formData.preferredStorageTemperature || null,
        preferredRelativeHumidity: formData.preferredRelativeHumidity || null,
        packagingMaterial: formData.packagingMaterial,
        
        // Marketing & Sales
        marketing: formData.marketing,
        typeOfProductSold: productTypes,
        typeOfMarketing: formData.typeOfMarketing,
        market: formData.market,
        marketplace: formData.marketplace,
        localMarket: formData.localMarket || null,
        international: formData.international || null,
        
        // Business Insights
        whatInterestYouToGoOnCacaoProcessing: formData.whatInterestYouToGoOnCacaoProcessing || null,
        challengesEncounteredInProcessing: formData.challengesEncounteredInProcessing || null,
        supportsNeededToImprove: formData.supportsNeededToImprove || null,
        futurePlans: formData.futurePlans || null,
        
        // Legacy field names for compatibility
        nameOfBusiness: formData.nameOfBusiness,
        nameOfTheOwner: formData.nameOfTheOwner,
        statusOfBusiness: formData.statusOfBusiness,
        lengthOfBusinessOperationInYears: formData.lengthOfBusinessOperationInYears ? parseInt(formData.lengthOfBusinessOperationInYears) : null,
        quantityOfCacaoBeansPerProcessingCycle: formData.quantityOfCacaoBeansPerProcessingCycle ? parseFloat(formData.quantityOfCacaoBeansPerProcessingCycle) : null,
        
        // Market Reach calculation
        marketReach: (() => {
          const isLocal = formData.localMarket === 'Yes';
          const isInternational = formData.international === 'Yes';
          
          if (isLocal && isInternational) {
            return 'Local & International';
          } else if (isInternational) {
            return 'International';
          } else if (isLocal) {
            return 'Local';
          } else {
            return 'Not specified';
          }
        })()
      };

      // Add to frontend state
      onAddProcessor(newProcessor);
      onClose();

    } catch (error) {
      
      // Show more detailed error message
      let errorMessage = 'Failed to add processor';
      if (error.message) {
        errorMessage = error.message;
      }
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      }
      
      setSubmitError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isStepValid = (step) => {
    switch (step) {
      case 1:
        return formData.nameOfBusiness && formData.nameOfTheOwner && formData.typeOfBusiness;
      case 2:
        return formData.quantityOfCacaoBeansPerProcessingCycle && formData.frequencyOfProcessing;
      case 3:
        return true; // Processing methods are optional
      case 4:
        return true; // Marketing fields are optional
      case 5:
        return true; // Business insights are optional
      default:
        return false;
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <ProcessorStep1BasicInfo
            formData={formData}
            handleInputChange={handleInputChange}
            handlePhoneChange={handlePhoneChange}
          />
        );
      case 2:
        return (
          <ProcessorStep2Operations
            formData={formData}
            handleInputChange={handleInputChange}
            cacaoVarieties={cacaoVarieties}
            newCacaoVariety={newCacaoVariety}
            setNewCacaoVariety={setNewCacaoVariety}
            addCacaoVariety={addCacaoVariety}
            removeCacaoVariety={removeCacaoVariety}
          />
        );
      case 3:
        return (
          <ProcessorStep3Methods
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      case 4:
        return (
          <ProcessorStep4Marketing
            formData={formData}
            handleInputChange={handleInputChange}
            productTypes={productTypes}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            addProduct={addProduct}
            removeProduct={removeProduct}
          />
        );
      case 5:
        return (
          <ProcessorStep5Insights
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      default:
        return null;
    }
  };

  const getStepTitle = (step) => {
    const titles = {
      1: 'Basic Information',
      2: 'Processing Operations', 
      3: 'Processing Methods',
      4: 'Marketing & Sales',
      5: 'Business Insights'
    };
    return titles[step];
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
        <Card className="border-0 shadow-none">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <CardTitle className="text-amber-900">{isEditMode ? 'Edit Processor' : 'Add New Processor'}</CardTitle>
                <p className="text-sm text-gray-600 mt-1">
                  Step {currentStep} of {totalSteps}: {getStepTitle(currentStep)}
                </p>
              </div>
              <Button type="button" variant="ghost" onClick={onClose} className="text-gray-500 hover:text-gray-700">
                <X className="h-4 w-4" />
              </Button>
            </div>
            
            {/* Progress Bar */}
            <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
              <div 
                className="bg-amber-600 h-2 rounded-full transition-all duration-300" 
                style={{ width: `${(currentStep / totalSteps) * 100}%` }}
              ></div>
            </div>
          </CardHeader>
          
          <CardContent>
            <form 
              onSubmit={handleSubmit} 
              onKeyDown={(e) => {
                // Prevent Enter key from submitting the form unless it's the submit button
                if (e.key === 'Enter' && e.target.type !== 'submit' && e.target.type !== 'button') {
                  e.preventDefault();
                }
              }}
              className="space-y-6"
            >
              {renderStep()}
              
              {/* Error Display */}
              {submitError && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <AlertCircle className="h-5 w-5 text-red-500 mr-2" />
                    <span className="text-red-800 font-medium">Error</span>
                  </div>
                  <p className="text-red-600 mt-1">{submitError}</p>
                </div>
              )}
              
              {/* Navigation Buttons */}
              <div className="flex justify-between items-center pt-6 border-t">
                <Button 
                  type="button" 
                  variant="outline" 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    prevStep();
                  }}
                  disabled={currentStep === 1 || isSubmitting}
                  className="flex items-center gap-2"
                >
                  <ChevronLeft className="h-4 w-4" />
                  Previous
                </Button>
                
                <div className="flex gap-2">
                  {Array.from({ length: totalSteps }, (_, i) => (
                    <div
                      key={i + 1}
                      className={`w-3 h-3 rounded-full ${
                        i + 1 <= currentStep ? 'bg-amber-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
                
                {currentStep < totalSteps ? (
                  <Button 
                    type="button" 
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      nextStep();
                    }}
                    disabled={!isStepValid(currentStep) || isSubmitting}
                    className="bg-amber-600 hover:bg-amber-700 flex items-center gap-2"
                  >
                    Next
                    <ChevronRight className="h-4 w-4" />
                  </Button>
                ) : (
                  <Button 
                    type="submit" 
                    className="bg-green-600 hover:bg-green-700 flex items-center gap-2"
                    disabled={!isStepValid(currentStep) || isSubmitting}

                  >
                    {isSubmitting && <Loader2 className="h-4 w-4 animate-spin" />}
                    {isSubmitting ? (isEditMode ? 'Updating Processor...' : 'Adding Processor...') : (isEditMode ? 'Update Processor' : 'Add Processor')}
                  </Button>
                )}
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
